var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import Inset from '../../../spacing/Inset';
import { colors } from '../../../../defaultTheme';
import { TableCellContent } from './TableCell';
const TH = styled.th `
  text-align: ${({ cellData }) => (cellData && cellData.align) || 'left'};
  ${({ isCardTable }) => isCardTable && `border-bottom: 1px solid ${colors.lightGrey};`}
`;
const TableHeader = (_a) => {
    var { className, cellData, isCardTable } = _a, props = __rest(_a, ["className", "cellData", "isCardTable"]);
    return (React.createElement(TH, Object.assign({ className: className, isCardTable: isCardTable, cellData: cellData, colSpan: cellData.colspan || 1 }, props),
        React.createElement(Inset, { horizontal: "medium", vertical: "large" },
            React.createElement(TableCellContent, null, cellData))));
};
export default TableHeader;
